import { Button } from "@/components/ui/button";
import BigDataChart from "@/components/ui/chart/BigDataChart";
import DonutChart from "@/components/ui/chart/DonutChart";
import HorizontalBarChart from "@/components/ui/chart/HorizontalBarChart";
import VerticalBarChart from "@/components/ui/chart/VerticalBarChart";
import useDatasetWidgetSummary from "@/hooks/dataset-widget/useDatasetWidgetSummary";
import { WidgetConfig, WidgetType } from "@/types/widget";

import WidgetConfigurationPopover from "./widgetConfiguration/WidgetConfigurationPopover";

interface DatasetWidgetCardProps {
  name: string;
  widget: WidgetConfig;
  onOpenWidgetConfig: () => void;
}

export default function DatasetWidgetCard({
  name,
  widget,
  onOpenWidgetConfig
}: Readonly<DatasetWidgetCardProps>) {
  const { rawData } = useDatasetWidgetSummary(widget);

  return (
    <div className="border border-gainsboro rounded-lg p-3">
      <div className="flex flex-col gap-3">
        <div className="flex items-center justify-between">
          <span className="text-base font-semibold text-txtHeading">
            {name}
          </span>
          <div className="flex flex-row items-center">
            <Button
              className="!no-underline text-sm font-semibold text-teal-500 "
              variant="link"
              onClick={() => {}}
            >
              Reset
            </Button>
            <WidgetConfigurationPopover
              onOpenWidgetConfig={onOpenWidgetConfig}
            />
          </div>
        </div>
        {widget.chart_type === WidgetType.BIG_NUMBER && (
          <BigDataChart value={10} type="MAX" />
        )}
        {widget.chart_type === WidgetType.BAR_H && (
          <HorizontalBarChart
            data={
              rawData?.map((data) => ({
                name: data.label,
                value: String(data.value)
              })) || []
            }
          />
        )}
        {widget.chart_type === WidgetType.DONUT && (
          <DonutChart
            data={
              rawData?.map((item) => ({
                name: item.label,
                value: Number(item.value)
              })) || []
            }
          />
        )}
        {widget.chart_type === WidgetType.BAR_V && (
          <VerticalBarChart
            data={
              rawData?.map((data) => ({
                name: data.label,
                key: data.value
              })) || []
            }
          />
        )}
      </div>
    </div>
  );
}
